{
  "commentConditions": "Uttryckta kommentarer publiceras {linkToDefinition} i Helsingfors stads tjänst {linkToLicense}. Du kan lämna din kommentar anonymt om du inte har loggat in. Dessutom redigeras texter vid behov på grund av kränkande eller annars osakligt språkbruk.",
  "fullscreenHeaderLogoAlt": "Helsingfors stads logo",
  "footerLogoAlt": "Helsingfors stads logo",
  "headerLogoAlt": "Gå till hemsidan",
  "copyrightHolder": "Helsingfors stad",
  "copyrightText": "Alla rättigheter förbehållna.",
  "footerCityLink": "www.hel.fi"
}
